import { RequestContractVehiclesDto } from "./RequestContractVehiclesDto";
import { RequestPartnerAddressDto } from "./RequestPartnerAddressDto";
import { RequestPoistkaDto } from "./RequestPoistkaDto";

export type RequestFormSettings = {
    availableVehicles: RequestContractVehiclesDto[];
    availableContracts: RequestPoistkaDto[];
    availableAddresses: RequestPartnerAddressDto[];
    previewMode: boolean;
    attachmentsRequired: boolean;
    attachmentsEnabled: boolean;
    uploadProcesses: boolean[];
    showFileLoading: boolean;
    requestSaving: boolean;
    globalInvalidErrorMessage: React.ReactNode;
    globalInfoMessage: string;
    sendNotification: boolean;
    displayFormSaveNotifText: boolean;
    isSuccessfulUpload: boolean;
    requestHasAiDetection: boolean;
    disableImmediateFileUpload: boolean;
    attachmentUploadMessage: string;
    attachmentValidationError: boolean;
    requestHasTaxonomies: boolean;
    odvetvieId: number;
    clientEmail: string;
    isCurrentUserRequest: boolean;
    manualSignRequired: boolean | null;
    isMagicLinkAvailable: boolean | null;
    signatureMethodCount: number;
    isUploadInProgress: boolean;
    autosaveStatus: 'idle' | 'saving' | 'saved';
    isBulkChangeOnContracts: boolean;
}

export const RequestFormSettingsSchema = {
    parse: (obj: Partial<RequestFormSettings>): RequestFormSettings => ({
        availableVehicles: [],
        availableContracts: [],
        availableAddresses: [],
        previewMode: false,
        attachmentsRequired: true,
        attachmentsEnabled: true,
        uploadProcesses: [],
        showFileLoading: false,
        requestSaving: false,
        globalInvalidErrorMessage: null,
        globalInfoMessage: "",
        sendNotification: true,
        displayFormSaveNotifText: false,
        isSuccessfulUpload: false,
        requestHasAiDetection: false,
        disableImmediateFileUpload: false,
        attachmentUploadMessage: "",
        attachmentValidationError: false,
        requestHasTaxonomies: false,
        odvetvieId: 0,
        clientEmail: "",
        isCurrentUserRequest: true,
        manualSignRequired: false,
        isMagicLinkAvailable: false,
        signatureMethodCount: 0,
        isUploadInProgress: false,
        autosaveStatus: 'idle',
        isBulkChangeOnContracts: false,
        ...obj,
    })
}
